import { render } from "./ProjectFilter.vue?vue&type=template&id=013819bb"
import script from "./ProjectFilter.vue?vue&type=script&lang=js"
export * from "./ProjectFilter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\aurel\\Desktop\\new-website\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__